import _slicedToArray from "/Users/henry/Documents/GitHub/creative-coding-2022/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/Users/henry/Documents/GitHub/creative-coding-2022/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: monospace;\n  font-weight: bold;\n  color: #fff;\n  background-color: #333;\n  border-radius: 4px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n"])));
var InputCarat = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: #f48fb1;\n  padding-right: 8px;\n"])));
var InputLine = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 8px;\n"])));
var ActiveInputLine = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n"])));
var Output = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: #ccc;\n  margin-top: 8px;\n  white-space: pre-wrap;\n"])));
var Error = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: #d33;\n  margin-top: 8px;\n  white-space: pre-wrap;\n"])));
var TextInput = styled.input(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: inherit;\n  font-weight: bold;\n  border: none;\n  outline: none;\n  flex-grow: 1;\n  caret-color: #f48fb1;\n  background-color: transparent;\n  font-family: monospace;\n"])));
var Header = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Title = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-left: 12px;\n  color: #888;\n"])));
var Tabs = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-bottom: 8px;\n"])));
var Tab = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  padding: 8px;\n  padding-left: 14px;\n  padding-right: 14px;\n  background-color: #222;\n  cursor: pointer;\n  &.selected {\n    background-color: #333;\n    color: #64b5f6;\n    cursor: auto;\n  }\n"])));
var TerminalContent = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  padding: 16px;\n  padding-top: 2px;\n  height: ", "px;\n  overflow-y: auto;\n"])), function (props) {
  return props.height;
});
export var ReactRepl = function ReactRepl(_ref) {
  var title = _ref.title,
      _ref$stealFocus = _ref.stealFocus,
      stealFocus = _ref$stealFocus === void 0 ? true : _ref$stealFocus,
      tabs = _ref.tabs,
      selectedTab = _ref.selectedTab,
      onChangeTab = _ref.onChangeTab,
      onClear = _ref.onClear,
      onSubmit = _ref.onSubmit,
      lines = _ref.lines,
      height = _ref.height;
  var inputRef = useRef();
  var terminalContentRef = useRef();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      activeInputValue = _useState2[0],
      setActiveInputValue = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      historySelectIndex = _useState4[0],
      setHistorySelectIndex = _useState4[1];

  useEffect(function () {
    if (!terminalContentRef.current) return;
    terminalContentRef.current.scrollTop = terminalContentRef.current.scrollHeight;
  }, [lines]);
  useEffect(function () {
    return setHistorySelectIndex(-1);
  }, [lines]);
  return /*#__PURE__*/React.createElement(Container, {
    onClick: function onClick() {
      return stealFocus ? inputRef.current.focus() : null;
    }
  }, (title || tabs) && /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Title, null, title), tabs && /*#__PURE__*/React.createElement(Tabs, null, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab, {
      className: tab === selectedTab ? "selected" : "",
      onClick: function onClick(e) {
        onChangeTab(tab);
        e.stopPropagation();
        e.preventDefault();
      },
      key: tab
    }, tab);
  }), onClear && /*#__PURE__*/React.createElement(Tab, {
    onClick: onClear
  }, "Clear"))), /*#__PURE__*/React.createElement(TerminalContent, {
    height: height,
    ref: terminalContentRef
  }, lines.map(function (line, i) {
    return line.type === "input" ? /*#__PURE__*/React.createElement(InputLine, {
      key: i
    }, /*#__PURE__*/React.createElement(InputCarat, null, ">"), line.value) : line.type === "output" ? /*#__PURE__*/React.createElement(Output, {
      key: i
    }, line.value) : /*#__PURE__*/React.createElement(Error, {
      key: i
    }, line.value.toString());
  }), /*#__PURE__*/React.createElement(ActiveInputLine, null, /*#__PURE__*/React.createElement(InputCarat, null, ">"), /*#__PURE__*/React.createElement(TextInput, {
    onKeyUp: function onKeyUp(e) {
      if (e.key === "Enter") {
        onSubmit(activeInputValue);
        setActiveInputValue("");
      } else if (e.key === "ArrowUp") {
        var newHSI = historySelectIndex + 1;
        var inputs = lines.filter(function (l) {
          return l.type === "input";
        });
        inputs.reverse();

        if (newHSI < inputs.length) {
          setActiveInputValue(inputs[newHSI].value);
          setHistorySelectIndex(newHSI);
        }
      } else if (e.key === "ArrowDown") {
        var _newHSI = historySelectIndex - 1;

        var _inputs = lines.filter(function (l) {
          return l.type === "input";
        });

        _inputs.reverse();

        if (_newHSI >= 0) {
          setActiveInputValue(_inputs[_newHSI].value);
          setHistorySelectIndex(_newHSI);
        }
      }
    },
    onChange: function onChange(e) {
      return setActiveInputValue(e.target.value);
    },
    value: activeInputValue,
    ref: inputRef
  }))));
};
export default ReactRepl;